import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { identity } from 'lodash/fp';
import { Popover } from 'antd';
import styles from './user-section.module.scss';
import userIconUrl from 'shared/images/user-icon.svg';
import classnames from 'classnames';
import { userSelector } from 'store/selectors/app-selectors';
import { UserLoginAsModal } from 'features/header/header-top-panel/user-section/user-loginas-dialog/user-loginas-dialog';
import { UserExitLoginAsModal } from 'features/header/header-top-panel/user-section/user-loginas-dialog/user-exit-loginas-dialog';
import { Button, Dropdown, Icon, IconButton } from '@placer-ui/components';
import { useWindowSize } from 'hooks/use-window-size';
import { screenLargeMin } from 'shared/constants/resolution-breakpoints';
import { getFeatureFlags } from 'core/flow-control';
import { UserSettingsMenu } from './user-settings-menu/user-setting-menu';

export const UserSectionDeprecated = () => {
    const user = useSelector(userSelector);
    const { width } = useWindowSize();

    const { accessibility_components_ff, enable_pi_in_the_platform } = getFeatureFlags();
    const [isPopoverVisible, setIsPopoverVisible] = useState<boolean>(false);
    const [impersonateModalOpen, setImpersonateModalOpen] = useState(false);
    const [exitImpersonateModeModalOpen, setExitImpersonateModeModalOpen] = useState(false);
    const togglePopover = () => setIsPopoverVisible(!isPopoverVisible);
    const onClose = () => {
        setImpersonateModalOpen(false);
    };

    const isSmallScreen = width < screenLargeMin;

    return (
        <>
            {accessibility_components_ff ? (
                <Dropdown
                    testId="user-section"
                    align="end"
                    closeOnSelection
                    trigger={
                        isSmallScreen || enable_pi_in_the_platform ? (
                            <IconButton
                                testId="user-section-button"
                                aria-label={'user-section-button'}
                                size="small"
                                variant="ghost"
                                Icon={
                                    <Icon
                                        type={'User'}
                                        weight={'duotone'}
                                        color={'gray'}
                                        size={24}
                                    />
                                }
                            />
                        ) : (
                            <div style={{ maxWidth: 203 }}>
                                <Button
                                    fullWidth
                                    testId="user-section-button"
                                    size="small"
                                    variant="text-gray"
                                    LeftIcon={
                                        <Icon
                                            type={'User'}
                                            weight={'duotone'}
                                            color={'gray'}
                                            size={24}
                                        />
                                    }
                                >
                                    {user?.username}
                                </Button>
                            </div>
                        )
                    }
                >
                    <UserSettingsMenu
                        setImpersonateModalOpen={setImpersonateModalOpen}
                        setExitImpersonateModeModalOpen={setExitImpersonateModeModalOpen}
                    />
                </Dropdown>
            ) : (
                <div
                    className={classnames(styles.userSectionWrapper, styles.noArrow)}
                    onClick={togglePopover}
                    data-testid="user-section-button"
                >
                    <Popover
                        content={
                            <UserSettingsMenu
                                setImpersonateModalOpen={setImpersonateModalOpen}
                                setExitImpersonateModeModalOpen={setExitImpersonateModeModalOpen}
                            />
                        }
                        trigger="click"
                        placement="bottomRight"
                        visible={isPopoverVisible}
                        onVisibleChange={togglePopover}
                        overlayClassName={classnames(styles.userSectionPopover, styles.noArrow)}
                        getPopupContainer={identity}
                        align={{
                            offset: [18, 3],
                        }}
                    >
                        <div className={styles.userSectionContent}>
                            <img src={userIconUrl} className={styles.userIcon} alt="user icon" />
                            {!enable_pi_in_the_platform && (
                                <div className={styles.userName}>{user?.username}</div>
                            )}
                        </div>
                    </Popover>
                </div>
            )}
            {impersonateModalOpen && (
                <UserLoginAsModal visible={impersonateModalOpen} onClose={onClose} />
            )}
            {exitImpersonateModeModalOpen && (
                <UserExitLoginAsModal visible={exitImpersonateModeModalOpen} />
            )}
        </>
    );
};
